var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Page',[_c('SiteMasthead',{attrs:{"thin":"true","title":"Notice of Intention to Leave"}}),_c('ContentRow',{attrs:{"noPaddingTop":true}},[_c('ContentContainer',[_c('SectionTitle',[_vm._v("Notice of Intention to Leave")]),_c('Form',{attrs:{"type":"Generic.AU.QLD.Form13Graphical"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }